'use strict';

var _ = require('lodash');
var SystemStatusInterfaceStatusFilterByFileEventsFactory = function SystemStatusInterfaceStatusFilterByFileEventsFactory(DataFilter, currentStateCriteriaService, configurationService) {
  function SystemStatusInterfaceStatusFilterByFileEvents() {
    DataFilter.call(this, ['system-status-interface-status-mode'], 'system-status-interface-status', 4);
  }
  SystemStatusInterfaceStatusFilterByFileEvents.constructor = SystemStatusInterfaceStatusFilterByFileEvents;
  SystemStatusInterfaceStatusFilterByFileEvents.prototype = Object.create(DataFilter.prototype);
  function createFilters(rules) {
    var allOptions = configurationService.getInterfaceStatusFileEvents();
    return _.reduce(rules, function (result, rule) {
      if (rule.field === 'fileEvent') {
        if (rule.operator === '=') {
          result = _.union(result, _.intersection(rule.leftOperand, allOptions));
        } else {
          result = _.union(result, _.difference(allOptions, rule.leftOperand));
        }
      }
      return result;
    }, []);
  }
  SystemStatusInterfaceStatusFilterByFileEvents.prototype.filter = function (data) {
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    var filter = createFilters(searchCriteria.rules);
    if (!_.size(filter)) {
      return data;
    }
    return DataFilter.prototype.filter(data, filter, 'event');
  };
  return SystemStatusInterfaceStatusFilterByFileEvents;
};
SystemStatusInterfaceStatusFilterByFileEventsFactory.$inject = ['DataFilterFactory', 'CurrentStateCriteriaService', 'ConfigurationService'];
module.exports = SystemStatusInterfaceStatusFilterByFileEventsFactory;